module.exports = __webpack_public_path__ + "media/click-btn.2c405a25.wav";